import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#8B7355',
      light: '#A0826D',
      dark: '#6B5344',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#F5E6D3',
      light: '#FAF3E8',
      dark: '#E8D4B8',
      contrastText: '#8B7355',
    },
    background: {
      default: '#FFFBF5',
    },
    text: {
      primary: '#5C4A3D',
      secondary: 'rgba(92,74,61,0.7)',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 700,
      fontSize: '3.5rem',
    },
    h2: {
      fontWeight: 600,
      fontSize: '2.5rem',
    },
  },
});
